
<re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>
<re-alert *ngIf="showMessage" type="success" (close)="showMessage = false">
  <strong *ngIf="userAction == 'CREATED'">New user {{userFirstName}} {{userLastName}} has been created.</strong>
  <strong *ngIf="userAction == 'Deactivate'">User {{userFirstName}} {{userLastName}} has been deactivated.</strong>
  <strong *ngIf="userAction == 'Suspend'">User {{userFirstName}} {{userLastName}} has been suspended.</strong>
  <strong *ngIf="userAction == 'Delete'">User {{userFirstName}} {{userLastName}} has been deleted.</strong>
  <strong *ngIf="userAction == 'Unlock'">User {{userFirstName}} {{userLastName}} has been unlocked.</strong>
  <strong *ngIf="userAction == 'Activate'">User {{userFirstName}} {{userLastName}} has been activated.</strong>
</re-alert>
<h1>User List</h1>

<fieldset>
  <div id="search-criteria">
    <div class="row">
      <div class="col-3">
        <div class="form-group">
          <label for="firstNameSearchField">First Name</label>
          <div>
            <input type="text" [disabled]="loading" id="firstNameSearchField" (keypress)="searchInputKeyPress($event)"
                   class="form-control" [value]="firstName"
                   (input)="firstName = $event.target.value.trim()"
                   (keyup.enter)="searchUsers()">
          </div>
          <p *ngIf="allowSearchText(firstName)" class="text-danger">Asterisk (*) and backslash (\) are not searchable characters.</p>
        </div>
      </div>

      <div class="col-3">
        <div class="form-group">
          <label for="lastNameSearchField">Last Name</label>
          <div>
            <input type="text" [disabled]="loading" id="lastNameSearchField" (keypress)="searchInputKeyPress($event)"
                   class="form-control" [value]="lastName"
                   (input)="lastName = $event.target.value.trim()"
                   (keyup.enter)="searchUsers()">
          </div>
          <p *ngIf="allowSearchText(lastName)" class="text-danger">Asterisk (*) and backslash (\) are not searchable characters.</p>
        </div>
      </div>

      <div class="col-5">
        <div class="form-group">
          <label for="userNameSearchField">Search By Username / Email / Employee Id / Federated LoginId </label>
          <div>
            <input type="text" [disabled]="loading" id="userNameSearchField" (keypress)="searchInputKeyPress($event)"
                   class="form-control" [value]="userName"
                   (input)="setSearchValues($event)"
                   (keyup.enter)="searchUsers()">
          </div>
          <p *ngIf="allowSearchText(userName)" class="text-danger">Asterisk (*) and backslash (\) are not searchable characters.</p>
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-3">
        <div class="form-group">
          <label for="userDropDown">Filter by status</label>
          <select2 (onSelect)="listUsersByStatusFilter($event)" [(ngModel)]="selectedStatusFilter"
                   [settings]="{width:'100%'}"
                   name="userDropDown" id="userDropDown"
                   [options]="statusDropdownOptions"></select2>
        </div>
      </div>
      <div class="col-3" *ngIf="isSupportUser || isCorporateAdmin">
        <div class="form-group">
          <label for="userDropDown2">Filter By IDM User Admin Access </label>
          <select2 (onSelect)="listUsersByUserAccessTypeFilter($event)" [(ngModel)]="selectedUserAccessTypeFilter"
                   [settings]="{width:'100%'}"
                   name="userDropDown2" id="userDropDown2"
                   [options]="statusUserAccessTypeOptions"></select2>
        </div>
      </div>

      <div class="col-3" *ngIf="isLocationAdmin || isLocationLimitedAdmin">
        <div class="form-group">
          <label>Filter by Location</label>
          <select2 (onSelect)="selectedLocationChanged($event)" [(ngModel)]="selectedLocation"
                   [settings]= "{width:'100%'}" [required]="true"
                   name="selectedLocation"
                   [options]="locationOptions"></select2>
        </div>
      </div>

      <div class="col-3" *ngIf="(isLocationAdmin || isLocationLimitedAdmin || isCorporateAdmin || isCorporateLimitedAdmin) && isPhysicianFeatureEnabled">
        <div class="form-group">
          <label>Filter by User Type</label>
          <select2 (onSelect)="selectedUserTypeChanged($event)" [(ngModel)]="selectedUserType"
                   [settings]="{width:'100%'}"
                   name="userTypeDropDown" id="userTypeDropDown"
                   [options]="userTypeOptions"></select2>
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <button [disabled]="loading" class="btn btn-default" type="button" (click)="clearSearch()">
            Clear all fields
          </button>
          <button [disabled]="loading || !allowSearch" class="btn btn-primary" type="button" (click)="searchUsers()">
            Search
          </button>
          <span class="spinner spinner-sm ml-3" *ngIf="loading">
            <span class="lspinner"></span>
          </span>
        </div>
      </div>
    </div>
  </div>
</fieldset>

<div class="row mt-3">
  <div class="col-6">
    <div class="form-group">
        <button *ngIf="!isSupportUser && !isCorporateLimitedAdmin && !isLocationLimitedAdmin" id="createNewUser" [disabled]="loading" class="btn btn-primary create-ssouser" routerLink="/user/new">
            <i class="fa fa-plus"></i> Create New User
        </button>

      <button class="btn btn-primary" *ngIf="isAdmin$|async" (click)="export()" [disabled]="loading || running" [routerLink]="[]">
        Export as CSV
      </button>
      <span class="spinner spinner-sm ml-3" *ngIf="running">
        <span class="lspinner"></span>
      </span>

    </div>
  </div>
  <div class="col-6  pull-right text-right justify-content-end">
      <span *ngIf="isLocationAdmin && selectedLocationName">
        <span class="font-weight-bold">Selected Location:</span>
        <span class="ml-2 mr-2">{{selectedLocationName}}</span>
      </span>
  </div>
</div>


<table class="table table-striped table-bordered" style="width:100%" id="userList">
</table>

<div class="spinner" *ngIf="loading">
  <div class="lspinner"></div>
</div>


<nav aria-label="page navigation" *ngIf="!loading && pagedItems?.length>0" id="userListNavigation">
  <div class="pagination-wrapper">
    <div class="page-size-container">
      <span>Show </span>
      <div ngbDropdown class="d-inline-block">
        <button id="dropdownBasic" class="btn btn-default" ngbDropdownToggle>{{getCurrentPageSize()}}</button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic">
          <button class="dropdown-item" (click)="updatePageSize(10)">10</button>
          <button class="dropdown-item" (click)="updatePageSize(25)">25</button>
          <button class="dropdown-item" (click)="updatePageSize(50)">50</button>
          <button class="dropdown-item" (click)="updatePageSize(75)">75</button>
          <button class="dropdown-item" (click)="updatePageSize(100)">100</button>
          <!--<button class="dropdown-item" (click)="updatePageSize(99999)">200</button>-->
        </div>
      </div>
      <span> entries</span>
    </div>
    <div class="pagination-container">
      <div *ngIf="pagination.pages && pagination.pages?.length" class="pagination justify-content-end">
        <button type="button" class="btn btn-default" [disabled]="pagination.currentPage === 1" (click)="paginate(1)" aria-label="First Page"><< First Page</button>
        <button type="button" class="btn btn-default" [disabled]="pagination.currentPage === 1" (click)="paginate(pagination.currentPage - 1)" aria-label="Previous Page">< Previous Page</button>
        <button type="button" class="btn btn-default" [disabled]="((pagination.currentPage === pagination.totalPages) && (mcNextLink === null))" (click)="paginateNext(pagination.currentPage + 1)" aria-label="Next Page">Next Page ></button>
      </div>
    </div>
  </div>
</nav>
